export const environment = {
  production: true,
  apiUrl: 'https://levelsapi.minatrades.com/api'
};
